import clsx from 'clsx'
import Image, { type ImageProps } from 'next/image'

type LogoIconProps = Omit<ImageProps, 'alt' | 'src' | 'width' | 'height'>

export function LogoIcon({ className, ...props }: LogoIconProps) {
  return (
    <Image
      alt="Glutenvrijadvies.nl logo"
      className={clsx('h-8 w-8 object-contain', className)}
      height={64}
      sizes="32px"
      src="/donker.png"
      width={64}
      {...props}
    />
  )
}
